export default "__VITE_ASSET__DT1na0l7__"